import { SvgIcon, type SvgIconProps } from "@mui/material";

export default function PalletsIcon(props: SvgIconProps) {
  const { fill } = props;
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      {...props}
      role="figure"
      fill="none"
      aria-label="Pallets Icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.71986 6.45581H1.60156V2.30078H22.3902V6.45581H19.2728V4.37604H13.5617V6.45581H10.4325V4.37604H4.71986V6.45581Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.72 14.0697H1.6017V9.91465H22.3904V14.0697H19.273V11.9899H13.5618V14.0697H10.4326V11.9899H4.72V14.0697Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.72 21.7008H1.6017V17.5458H22.3904V21.7008H19.273V19.621H13.5618V21.7008H10.4326V19.621H4.72V21.7008Z"
        fill={fill}
      />
    </SvgIcon>
  );
}
